namespace advisorop.components.common {
    
    class AssignCuHouseholdController {
        account: domains.IAccount;

        selInvestor: domains.IInvestor;
        selHousehold: domains.IHousehold;
        isHouseholdFormVisible: boolean = false;
        
        static $inject = ["advisorService", "accountApi"];
        constructor(private advisorService: services.AdvisorService,
            private accountApi: services.AccountApi) {
        }

        loadAccount(accountId: number) {
            this.accountApi.getById(accountId)
                .success((data) => {
                    this.account = data;
                })
                .error((data, status) => {
                    toastr.error("Error " + status + " " + data);
                });

        };

        linkAccountAndHousehold(): void {

            let link: domains.IAccountGroupAccount = {};

            link.accountId = this.account.id;
            link.id = 0;
            link.investorId = this.selInvestor.id;
            link.accountGroup = {                
                householdId: this.selHousehold.id,
                id: 0                               
            };
            
            //console.log("Adding account to household... ");
            //console.log(link);


            this.advisorService.addAccountToHousehold(link)
                .success((data) => {
                    link = data;
                    for (var i = 0; i < this.account.manualAccount.households.length; i++) {
                        if (this.account.manualAccount.households[i].investorId == this.selInvestor.id)
                        {
                            this.account.manualAccount.households[i] = link;
                            break;
                        }
                    };
                    this.selInvestor = null;
                    this.selHousehold = null;           
                })
                .error((data, status) => {
                    toastr.error("Adding account to household error " + status + " " + data);
                });
        };
        
        showHideHouseholdForm(): void {
            if (this.isHouseholdFormVisible) {
                this.isHouseholdFormVisible = false; // hide
            }
            else {                
                this.onChangeHousehold(this.selInvestor);
                this.isHouseholdFormVisible = true;
            }
        };
        
        onChangeHousehold(investor: domains.IInvestor): void {

            if (!investor)
                return;

            this.selInvestor = investor;

            this.advisorService.getAllHouseholdsByInvestor(investor.id)
                .success((data) => {
                    investor.households = data;
                })
                .error((data, status) => {
                    toastr.error("Household Error " + status + " " + data);
                });
        };
        
        householdCu(household: domains.IHousehold): void {            
            this.selHousehold = household;
            if (household)
                this.linkAccountAndHousehold();
        };
        
        $onInit(): void {            
        }

        $onChanges(evt): void {
            //{ currentValue, previousValue, isFirstChange() }                        
            for (var key in evt) {
                //if (key === "accountId") {
                //    console.log("Loading account..." + this.accountId);
                //    this.loadAccount(this.accountId);
                //}
            }
        }        
    }


    class AssignCuHousehold implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        
        constructor() {
            this.controller = AssignCuHouseholdController;
            this.controllerAs = "vm";
            this.bindings = {
                account: "<"
            };
            this.templateUrl = "spa/shared/common/assign-cu-household.html";
        }        
    }
    angular.module(Constants.APP).component("assignCuHousehold", new AssignCuHousehold());    
}